export const PATIENT_COPING_TIP_CONFIG_V1 = 'PATIENT_COPING_TIP_CONFIG_V1';

export interface PatientCopingTipConfigV1 {
  module: PatientCopingTipModuleV1;
}

export enum PatientCopingTipModuleV1 {
  GI_TOX = 'GI_TOX',
  SYMPTOM_TRACKER = 'SYMPTOM_TRACKER',
}
